import {isEmpty} from 'lodash';

export default {
  registerFormLoading: state => {
    return state.registerFormLoading;
  },
  registerFormError: state => {
    return state.registerFormError;
  },
  registerFormNonFieldErrors: state => {
    return state.registerFormError && !isEmpty(state.registerFormError.non_field_errors)
      ? state.registerFormError.non_field_errors
      : '';
  },
  clientRegisterForm: state => {
    return state.clientRegisterForm;
  },
  candidateRegisterForm: state => {
    return state.candidateRegisterForm;
  }
};
